import { Button, Intent, TextArea } from '@blueprintjs/core';
import { Target } from '@retro-ui/api-contract';
import { styled } from '@moleculeone/ui';
import { ChangeEvent, useState } from 'react';

import { parseTargetInput } from '../utils/parseTargetInput';

const DataInputContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
});

interface DataInputProps {
  updateTargets: (targets: Target[]) => void;
}

export function DataInput(props: DataInputProps) {
  const { updateTargets } = props;

  const [inputData, setInputData] = useState('');

  const processData = () => {
    const parsedValue = parseTargetInput<Target>(inputData);

    const newTargets = parsedValue.data.map(item => {
      return { smiles: item[0], name: item[1] };
    });

    updateTargets(newTargets);
  };

  const handleInputChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setInputData(event.target.value);
  };

  return (
    <DataInputContainer>
      <TextArea
        data-cy="targets-textarea"
        value={inputData}
        onChange={handleInputChange}
        placeholder={`O=C(O)CC, target1
FC(F)(F)c1nnc2CNCCn12
Cc1cnc(C(=O)O)c(OC(F)F)c1, target3
...`}
        rows={5}
        cols={100}
        small
      />
      <Button
        data-cy="process-data-button"
        outlined
        intent={Intent.PRIMARY}
        onClick={processData}
        disabled={!inputData}
      >
        Process data
      </Button>
    </DataInputContainer>
  );
}
